var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 4,
    viewBox: "0 0 15 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05335 1H12.7556C12.9634 1 13.1628 1.08257 13.3097 1.22954C13.4567 1.37652 13.5393 1.57585 13.5393 1.78371C13.5393 1.99156 13.4567 2.1909 13.3097 2.33787C13.1628 2.48484 12.9634 2.56741 12.7556 2.56741H8.05335H1.78371C1.57585 2.56741 1.37652 2.48484 1.22954 2.33787C1.08257 2.1909 1 1.99156 1 1.78371C1 1.57585 1.08257 1.37652 1.22954 1.22954C1.37652 1.08257 1.57585 1 1.78371 1H8.05335Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.56741
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.6d62ec6dafe17b746c06aa3aae1e688a.svg";
export { ForwardRef as ReactComponent };